import { useMemo } from "react";
import { useSelector } from "react-redux";
import { decodeJwt } from "../utils/jwt";

/**
 * The logged-in user, from the access token (sub, employeeId, role,
 * companyId, branchId) with the auth state as a fallback.
 */
const useCurrentUser = () => {
  const auth = useSelector((s) => s.auth);
  return useMemo(() => {
    const claims = decodeJwt(auth.accessToken) || {};
    const role = claims.role || auth.role || "";
    return {
      userId: claims.sub || auth.user?.sub || auth.user?.id || null,
      employeeId: claims.employeeId ?? null, // null = account not linked to an employee
      role,
      // Super admin: no company in the token → the working company picked in the top bar
      companyId: claims.companyId || auth.companyId || null,
      noCompany:
        !!auth.accessToken && (auth.noCompany || claims.companyId === null),
      branchId: claims.branchId || auth.branchId || null,
    };
  }, [
    auth.accessToken,
    auth.role,
    auth.user,
    auth.companyId,
    auth.branchId,
    auth.noCompany,
  ]);
};

export default useCurrentUser;
